import { createAsyncThunk } from "@reduxjs/toolkit";
import { IFiltersData } from "src/@types/filtering";
import { instance } from "src/services/api-client";

export const FILTERS_SLICE_NAME = "filters";

export const getFiltersValuesAsync = createAsyncThunk(
  `${FILTERS_SLICE_NAME}/fetchFiltersValues`,
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await instance.get<IFiltersData>(`/clones/values/`);

      return data;
    } catch ({ response }) {
      const errorText = response?.data?.error;

      return rejectWithValue(errorText);
    }
  }
);
